import { render, staticRenderFns } from "./PreviewImageElement.vue?vue&type=template&id=3b123e44&"
import script from "./PreviewImageElement.vue?vue&type=script&lang=js&"
export * from "./PreviewImageElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports